// extracted by css-extract-rspack-plugin
export default {"refundDialogV2Container":"refundDialogV2Container-JfmYTY"};